const wrapRootElement = require('./src/wrap-root-element').default

exports.wrapRootElement = wrapRootElement

exports.onClientEntry = () => {
  const {
    installSentryAxiosAdapter,
  } = require('./src/utils/sentryAxiosAdapter')
  installSentryAxiosAdapter()
  const LocalStorageInterceptor = require('./src/utils/localStorageInterceptor')
    .default
  const localStorageConfigs = require('./src/config/localStorage').default
  LocalStorageInterceptor.init(localStorageConfigs)
}

exports.onRouteUpdate = () => {
  const LocalStorageInterceptor = require('./src/utils/localStorageInterceptor')
    .default
  LocalStorageInterceptor.validate()
}
